import { createContext } from 'react'

import { defaultValue } from './data'

const AmplitudeContext = createContext(defaultValue)

export default AmplitudeContext
